import { NavLink, NavLinkProps } from "react-router-dom";
import { Button, ButtonProps } from "@mui/material";

type NavButtonProps = ButtonProps &
  NavLinkProps & {
    to: string;
    /**
     * If true, adds extra inline padding to the button.
     */
    padded?: boolean;
  };

/**
 * A MUI Button that navigates using react-router's NavLink.
 */
export const NavButton: React.FC<NavButtonProps> = (props: NavButtonProps) => {
  const { padded, ...rest } = props;
  let styleProps: ButtonProps["sx"];
  if (padded) {
    styleProps = { px: 4 };
  }
  return <Button component={NavLink} variant="contained" sx={styleProps} {...rest} />;
};
